
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSSalesGrid extends _Ext.GridBase<POSSalesRow, any> {
        protected getColumnsKey() { return 'Retail.POSSales'; }
        protected getDialogType() { return POSSalesDialog; }
        protected getIdProperty() { return POSSalesRow.idProperty; }
        protected getInsertPermission() { return POSSalesRow.insertPermission; }
        protected getLocalTextPrefix() { return POSSalesRow.localTextPrefix; }
        protected getService() { return POSSalesService.baseUrl; }
        rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container);
            this.toolbar.findButton('add-button').find('.button-inner').text('New Invoice');
            this.slickGrid.setOptions({ rowHeight: 30 });

            //this.addButtonClick();
        }

        protected addButtonClick() {

            let now = new Date();
            var voucher = FormatHelper.GetVoucherNo(48);

            var userDefinition = Q.Authorization.userDefinition;
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[48].AutoPosting;
            this.editItem(<POSSalesRow>{
                VoucherNo: voucher,
                Line_No: 0,
                VoucherTypeId: 48,
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                TransDate: now.toDateString(),
                AutoPosting: autoposting
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}